import instance from "../../axios";
import { getCompanies } from "../../Helpers";
import { asArray, parseApiError, toSelectOption, toQuery, unwrapPage } from "../identity/apiError";
import { contractTypeFromTab } from "../identity/formDefaults";
import { accountDataFormat, buildCreatePayload } from "../identity/formatters";

export const listAccounts = async ({
  userId,
  page = 1,
  pageSize = 20,
  search = "",
  tab = "maintenance",
  extraQuery = "",
}) => {
  const contractType = contractTypeFromTab(tab);
  const query = toQuery({
    userId,
    contractType,
    all: true,
    page,
    limit: pageSize,
    search,
  });
  const payload = await instance.get(`/api/accounts/get?${query}${extraQuery || ""}`);
  return unwrapPage(payload);
};

export const createIdentity = async (form, accountsform, extras = {}) => {
  const { url, body } = buildCreatePayload(form, accountsform, extras);
  return instance.post(url, body);
};

export const updateAccount = (id, selectedAccount, form, accountsform) =>
  instance.put(`/api/accounts/${id}`, accountDataFormat(selectedAccount, form, accountsform));

export const deleteAccount = (account) =>
  instance.delete(`/api/accounts/${account.id}`, { data: account });

export const activateAccount = (id, currentlyActive) =>
  instance.put(`/api/accounts/${currentlyActive ? "inactive" : "active"}/${id}`);

export const getAccountTerms = (accountId) =>
  instance.get(`/api/accounts/${accountId}/terms`);

export const getAccountFiles = (accountId) =>
  instance.get(`/api/uploads/get?entityId=${accountId}&entity=Account`);

export const deleteUpload = (mediaId) => instance.delete(`/api/uploads/${mediaId}`);

export const listAccountManagers = async (search = "") => {
  const data = await instance.get(
    `/api/users/getAllUsersInSystem?search=${encodeURIComponent(search)}&userTypes=4`,
  );
  return asArray(data).map(toSelectOption);
};

export const listVehicles = async (userId) => {
  const data = await instance.get(`/api/vehicles/list?userId=${userId}&page=1&limit=100`);
  return asArray(data?.data || data).map(toSelectOption);
};

export const listCompanies = async () => {
  const data = await getCompanies();
  return asArray(data).map(toSelectOption);
};

export const listGarages = async (userId, search = "") => {
  const data = await instance.get(
    `/api/garages/get?userId=${userId}&page=1&limit=50&all=true${
      search ? `&search=${encodeURIComponent(search)}` : ""
    }`,
  );
  return asArray(data).map((item) => ({
    id: item.id,
    key: item.id,
    name: `${item.name} - ${item.garageNumber}`,
    label: `${item.name} - ${item.garageNumber}`,
    uniqueId: item.id,
    valueType: "string",
    garageNumber: item.garageNumber,
  }));
};

export const listParentUsers = async (accountId) => {
  const data = await instance.get(`/api/users/list?accountId=${accountId}&limit=1000`);
  return asArray(data).map(toSelectOption);
};

export const listAccountsForPicker = async (accountId, logInUser) => {
  const all = logInUser?.userType === -1 ? "&all=true" : "";
  const url =
    logInUser?.userType === -1
      ? `/api/accounts/all?accountId=${accountId}${all}&limit=1000`
      : `/api/accounts/list?accountId=${accountId}&limit=1000`;
  const data = await instance.get(url);
  return asArray(data).map(toSelectOption);
};

export const countDevices = (userId) => instance.get(`/api/devices/count?userId=${userId}`);
export const countUsers = (userId) => instance.get(`/api/users/count?userId=${userId}`);
export const countVehicles = (userId) => instance.get(`/api/vehicles/count?userId=${userId}`);

export const assignPermission = (payload) => instance.post("/api/permissions", payload);

export const handleIdentityError = (error, translate) => parseApiError(error, translate);
